import React, { useState } from 'react';
import FormLayout from '../components/FormLayout';
import VehicleForm from '../components/VehicleForm';
import { ophaalFormConfig } from '../config/forms';
import { t } from '../locales/nl';

const OphaalForm: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('');

  return (
    <FormLayout 
      title={t.ophaalFormTitle}
      currentSection={currentSection}
    >
      <VehicleForm 
        formType="ophaal"
        formConfig={ophaalFormConfig}
        onSectionChange={setCurrentSection}
      />
    </FormLayout>
  );
};

export default OphaalForm;